<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Display Language'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>

      @if (loaded) {
        <tidy-card>
          <form [formGroup]="form" novalidate action="#" class="messages-form-filters">
            <tidy-select
              class="messages-select-custom-input"
              [icon]="'assets/svg/language.svg'"
              [label]="'Language'"
              [items]="languageItems"
              [form]="form.get('language')"
              formControlName="language"
              (optionChange)="changeLanguage($event)" />
          </form>
        </tidy-card>
        <tidy-button
          [text]="'Save Language'"
          [action]="boundSave"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
